import React, { ReactElement } from 'react';
import SurveyListingPage from './listing/listingpage';

function Surveys(): ReactElement {
  return (
    <SurveyListingPage />
  );
}

export default Surveys;